import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-radio-card',
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    MatIconModule
  ],
  templateUrl: './radio-card.component.html',
  styleUrl: './radio-card.component.css'
})
export class RadioCardComponent {
  @Input({ required: true }) value!: string;
  @Input({ required: true }) isSelected!: boolean;
  @Input() contentTemplate!: TemplateRef<any>;
  @Input() expandedTemplate: TemplateRef<any> | null = null; 
  @Input() isExpanded: boolean = false;
  @Input() customClasses: string = '';

  @Output() cardClick = new EventEmitter<string>();

  onClick(): void {
    this.cardClick.emit(this.value);
  }
}